import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextareaAutogrowDirective } from './textarea-autogrow.directive';

@NgModule({
  declarations: [
    TextareaAutogrowDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TextareaAutogrowDirective
  ]
})
export class TextareaAutogrowModule { }
